import React, { useEffect, useState, useCallback } from 'react';
import { Button, Container, Row, Col } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getPurchaseRebateProduct,
  getPurchaseRebateItem,
} from '../../actions/purchaseRebateActions';
import { BeatLoader } from 'react-spinners';
import moment from 'moment';

const PurchaseRebateDetails = () => {
  const dispatch = useDispatch();
  const { funderId } = useParams();

  const purchaseRebateDetails = useSelector(
    (state) => state.purchaseRebateProductItems,
  );
  const purchaseRebateInfo = useSelector((state) => state.purchaseRebateItem);
  const isLoading = useSelector(
    (state) => state.purchaseRebateProductItemsIsLoading,
  );

  const [emptyRowString, setEmptyRowString] = useState('');

  useEffect(() => {
    if (funderId) {
      dispatch(getPurchaseRebateProduct(funderId));
      dispatch(getPurchaseRebateItem(funderId));
    }
  }, [dispatch, funderId]);

  const dateReturner = useCallback((date) => {
    if (date == null || date === '01-01-0001') {
      return 'No effective date';
    }
    return moment.utc(date).local().format('DD-MM-YYYY');
  }, []);

  const noRowsExist = (
    <Row>
      <Col md='12'>{emptyRowString}</Col>
    </Row>
  );

  const fundersRows =
    purchaseRebateDetails && purchaseRebateDetails.length > 0
      ? purchaseRebateDetails.map((prDetails) => (
          <div className='panel panel-default' key={prDetails.Id}>
            <Row>
              <Col md='1' className='white-border'>
                {prDetails.productCode}
              </Col>
              <Col md='3' className='white-border'>
                {prDetails.productDescription}
              </Col>
              <Col md='3' className='white-border'>
                {prDetails.costLevel}
              </Col>
              <Col md='3' className='white-border'>
                {dateReturner(prDetails.effDate)}
              </Col>
              <Col md='2' className='white-border'>
                {prDetails.rebateAmount}
              </Col>
            </Row>
          </div>
        ))
      : noRowsExist;

  const prIntro =
    purchaseRebateInfo && funderId ? (
      <h4>
        Purchase Rebate Details for - {purchaseRebateInfo.offerFunderId} (
        {purchaseRebateInfo.rebateName}){' '}
      </h4>
    ) : (
      noRowsExist
    );

  return (
    <div>
      {prIntro}
      <Link to='/purchase-rebate'>
        <Button
          color='primary'
          className='mb-3 mt-3'
          name='btnAddNew'
          id='btnAddNew'
        >
          Back
        </Button>
      </Link>
      <Container fluid>
        <Row>
          <Col md='1' className='column-header white-border'>
            SKU
          </Col>
          <Col md='3' className='column-header white-border'>
            Product Description
          </Col>
          <Col md='3' className='column-header white-border'>
            Cost Level
          </Col>
          <Col md='3' className='column-header white-border'>
            Effective Date
          </Col>
          <Col md='2' className='column-header white-border'>
            Rebate Amount
          </Col>
        </Row>
        {fundersRows}
        <Row>
          <Col>
            <BeatLoader color={'#004C5F'} loading={isLoading} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PurchaseRebateDetails;
